export default __webpack_public_path__ + "static/media/math.309a922b.png";